var React = require('react');

function MenuCloseIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.09933 7.50012L14.6688 1.93052C15.1104 1.48896 15.1104 0.772722 14.6688 0.331167C14.2273 -0.110389 13.5111 -0.110389 13.0695 0.331167L7.5 5.90077L1.93049 0.331167C1.48894 -0.110389 0.77271 -0.110389 0.331162 0.331167C-0.110387 0.772722 -0.110387 1.48896 0.331162 1.93052L5.90068 7.50012L0.331162 13.0697C-0.110387 13.5113 -0.110387 14.2275 0.331162 14.6691C0.551467 14.8903 0.841146 15 1.13082 15C1.4205 15 1.70924 14.8894 1.93049 14.6691L7.5 9.09947L13.0695 14.6691C13.2908 14.8903 13.5795 15 13.8692 15C14.1589 15 14.4476 14.8894 14.6688 14.6691C15.1104 14.2275 15.1104 13.5113 14.6688 13.0697L9.09933 7.50012Z","fill":"#B9BFC5"}));
}

MenuCloseIcon.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = MenuCloseIcon;

MenuCloseIcon.default = MenuCloseIcon;
